<template>
  <div id="mChartDom" ref="mChartDom" ></div>
</template>

<script>
export default {
  name: "mChartDom",
  props: {
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultOption: {
        series: [],
        tooltip: {
          trigger: "item"
        }
      },
      myChart: undefined
    };
  },

  methods: {
    myChartResize() {
      this.myChart?.resize();
    },
    setOption: function() {
      const dom = this.$refs?.mChartDom;
      if (!dom) return false;
      this.myChart = this.$echarts.init(dom);
      window.addEventListener("resize", this.myChartResize, false);
      this.myChart?.setOption({ ...this.defaultOption, ...this.option });
    }
  },
  mounted() {
    this.setOption();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.myChartResize, false);
  },
  watch: {
    "option":  {
      handler() {
        this.setOption();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
#mChartDom {
  width: 100%;
  height: 100%;
  min-height: 100px;
}
</style>
